import { gql } from "@apollo/client";

export const removeCompanyPolicy = gql`
  mutation removeCompanyPolicy($_id: MongoID!) {
    companyPolicy_RemoveById(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
